export function headerFunc() {
  toggleMenu()
  navSubMenuHover()
  navSubMenuToggle()
  headerScroll()
}

/**
 * ハンバーガーメニュー
 */
function toggleMenu() {
    const toggleButton = document.querySelector('.l-header__toggle');
    const navWrap = document.querySelector('.l-header__nav-wrap');
    const logo = document.querySelector('.l-header__logo');

    if (!toggleButton || !navWrap) return;

    toggleButton.addEventListener('click', function() {
      const isOpen = toggleButton.classList.toggle('l-header__toggle--close');

      navWrap.classList.toggle('is-open', isOpen);
      if (logo) {
        logo.classList.toggle('is-open', isOpen);
      }

      if (!isOpen) {
        closeAllSubMenus();
      }
    });
}

/**
 * PC時のサブメニューホバー
 */
function navSubMenuHover() {
  const mediaQuery = window.matchMedia('(min-width: 1024px)');
  const CLOSE_DELAY = 200;
  const navItems = document.querySelectorAll('.l-header__nav-list-wrap > li:has(ul)');
  const closeTimers = new WeakMap();

  if (!navItems.length) return;

  const openSubMenu = (item) => {
    const link = item.querySelector(':scope > a');
    const subMenu = item.querySelector(':scope > ul');
    if (!link || !subMenu) return;

    link.classList.add('is-child-open');
    subMenu.classList.add('is-open');
  };

  const closeSubMenu = (item) => {
    const link = item.querySelector(':scope > a');
    const subMenu = item.querySelector(':scope > ul');
    if (!link || !subMenu) return;

    link.classList.remove('is-child-open');
    subMenu.classList.remove('is-open');
  };

  const clearCloseTimer = (item) => {
    const timer = closeTimers.get(item);
    if (!timer) return;

    clearTimeout(timer);
    closeTimers.delete(item);
  };

  const scheduleCloseSubMenu = (item) => {
    clearCloseTimer(item);
    closeTimers.set(item, setTimeout(() => {
      closeSubMenu(item);
      closeTimers.delete(item);
    }, CLOSE_DELAY));
  };

  navItems.forEach((item) => {
    const link = item.querySelector(':scope > a');
    const subMenu = item.querySelector(':scope > ul');
    if (!link || !subMenu) return;

    const handleEnter = () => {
      if (!mediaQuery.matches) return;
      clearCloseTimer(item);
      openSubMenu(item);
    };

    const handleLeave = () => {
      if (!mediaQuery.matches) return;
      scheduleCloseSubMenu(item);
    };

    [link, subMenu].forEach((el) => {
      el.addEventListener('mouseenter', handleEnter);
      el.addEventListener('mouseleave', handleLeave);
    });
  });

  mediaQuery.addEventListener('change', (e) => {
    if (!e.matches) {
      navItems.forEach((item) => {
        clearCloseTimer(item);
        closeSubMenu(item);
      });
    }
  });
}

/**
 * SP時のサブメニュー開閉
 */
function navSubMenuToggle() {
  const mediaQuery = window.matchMedia('(max-width: 1023px)');
  const navItems = document.querySelectorAll('.l-header__nav-list-wrap > li:has(ul)');

  if (!navItems.length) return;

  navItems.forEach((item) => {
    const link = item.querySelector(':scope > a');
    const subMenu = item.querySelector(':scope > ul');
    if (!link || !subMenu) return;

    link.addEventListener('click', (e) => {
      if (!mediaQuery.matches) return;

      e.preventDefault();

      const isOpen = subMenu.classList.contains('is-open');

      navItems.forEach((otherItem) => {
        if (otherItem === item) return;

        const otherLink = otherItem.querySelector(':scope > a');
        const otherSubMenu = otherItem.querySelector(':scope > ul');
        if (!otherLink || !otherSubMenu) return;

        otherLink.classList.remove('is-child-open');
        otherSubMenu.classList.remove('is-open');
      });

      link.classList.toggle('is-child-open', !isOpen);
      subMenu.classList.toggle('is-open', !isOpen);
    });
  });

  mediaQuery.addEventListener('change', (e) => {
    if (!e.matches) {
      closeAllSubMenus();
    }
  });
}

function closeAllSubMenus() {
  const navItems = document.querySelectorAll('.l-header__nav-list-wrap > li:has(ul)');

  navItems.forEach((item) => {
    const link = item.querySelector(':scope > a');
    const subMenu = item.querySelector(':scope > ul');
    if (!link || !subMenu) return;

    link.classList.remove('is-child-open');
    subMenu.classList.remove('is-open');
  });
}

/**
 * スクロール時のヘッダー状態
 */
function headerScroll() {
  const header = document.querySelector('.l-header');
  if (!header) return;

  let lastScrollY = window.scrollY;

  const updateScrollClass = () => {
    const currentScrollY = window.scrollY;

    header.classList.toggle('is-scroll', currentScrollY > 100);

    if (currentScrollY > lastScrollY) {
      header.classList.add('is-scroll-bottom');
      header.classList.remove('is-scroll-top');
    } else if (currentScrollY < lastScrollY) {
      header.classList.add('is-scroll-top');
      header.classList.remove('is-scroll-bottom');
    }

    lastScrollY = currentScrollY;
  };

  window.addEventListener('scroll', updateScrollClass, { passive: true });
  updateScrollClass();
}